import EmptySupplierIcon from './svg/empty/customer-supplier-empty.svg'

export default EmptySupplierIcon
